module.exports = __webpack_public_path__ + "resources/img/img_security_dfinder_fds2_m_en.581964e730162a318a4b9aba6d5d1dbd.png";